require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./winpe-wob-independent-directors-dilemma.json") })
        }
      }, "path---winpe-wob-independent-directors-dilemma");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---winpe-wob-independent-directors-dilemma!./.cache/json/winpe-wob-independent-directors-dilemma.json
// module id = 1278
// module chunks = 231608221292675